<template>
  <div class="portfolio_section">
    <base-row>
      <base-column>
        <base-heading :type-array="['my work', 'my passion']">
          <template v-slot:default>portfolio</template>
        </base-heading>
      </base-column>
      <base-column :col-lg="4" :col="6" :col-sm="12" v-for="project in projects" :key="project.id">
        <portfolio-project :link="project.link" :img-src="project.img" :tags="project.tags">
          <template v-slot:default>{{ project.title}}</template>
          <template v-slot:sub>{{project.description}}</template>
        </portfolio-project>
      </base-column>
    </base-row>
  </div>

</template>

<script>
import PortfolioProject from "@/components/portfolio/PortfolioProject";


export default {
  components: {PortfolioProject},
  computed: {
    projects(){
      return this.$store.getters['projects/getProjects'];
    }
  }
}
</script>

<style scoped>
.portfolio_section {
  width: 100%;
  min-height: 100vh;
  background-color: white;
  padding-top: 3rem;
}
</style>